<template>
  <div>
    <span
      v-if="reviews.length <= 0"
      class="desc-text"
      >
      {{ $t('api.noData') }}
    </span>
    <el-card class="box-card"
      v-for="review in reviews"
      :key="review.id">
      <el-form-item
        :label="getTransText('rating', 'label', base)"
        class="item-description"
        >
        <el-rate
          v-model="review.rating"
          show-score
          text-color="#ff9900"
          :score-template="getTransText('rating', 'score', base)"
          >
        </el-rate>
      </el-form-item>
      <text-field
        v-model="review.description"
        :base="base"
        name="review_description"
        type="textarea"
        :disabled="false"
        >
      </text-field>
      <remote-opt
        v-model="tagOpt"
        :base="base"
        name="review_tag"
        :labelArr="['id', 'name']"
        :inputList="tags"
        :fetchList="fetchTagList"
        multiple
        :baseFilter="'{type:6}'"
        :srchFilter="prodtagFilter(6)"
        :isAllowSort="false"
        :isAutoFetch="false"
        >
      </remote-opt>
      <time-field
        v-model="review.created_at"
        :base="base"
        name="review_created_at"
        disabled
        >
      </time-field>
      <el-button type="primary"
                 @click="reviewUpdateOne(review.id, review)"
                 :loading="submitLoading"
      >
        {{ $t('api.saveBtn') }}
      </el-button>
      <el-tooltip class="item" effect="dark" lacement="top" :content="delDesc">
        <el-button type="danger" icon="el-icon-delete" @click="reviewDeleteOne(review.id)">
          {{ $t('api.orders.review.delBtn')}}
        </el-button>
      </el-tooltip>
    </el-card>
  </div>
</template>

<script>

import { fetchList as fetchTagList } from '@/api/region/prodtag'
import { updateOne, deleteOne } from '@/api/orders/orders_review'
import { getTransText } from '@/utils/i18n'
import { objsToOpts, optsToObjs } from '@/utils/mselect'
import { prodtagFilter } from '@/utils/filter'

export default {
  name: 'orders-review',
  props: {
    base: {
      type: String,
      default: ''
    },
    reviews: {
      type: Array,
      default: () => []
    },
    reviewTags: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tagOpt: [],
      tags: [],
      submitLoading: false
    }
  },
  created () {
    this.initForm()
  },
  computed: {
    delDesc () {
      return this.$t('api.orders.review.delDesc')
    }
  },
  methods: {
    prodtagFilter,
    getTransText,
    fetchTagList,
    reviewUpdateOne (reviewId, review) {
      this.submitLoading = true
      review.tags = optsToObjs(this.tagOpt)
      updateOne(reviewId, review).then(response => {
        this.$message({
          message: this.$t('api.orders.review.editSuccess'),
          type: 'success',
          duration: 2000
        })
        this.submitLoading = false
      }).catch(err => {
        console.log(err)
        this.submitLoading = false
      })
    },
    reviewDeleteOne (reviewId) {
      let msg = this.$t('api.orders.review.delConfirmMsg')
      let title = this.$t('api.delConfirmTitle')
      this.$confirm(msg, title, {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        deleteOne(reviewId).then(response => {
          this.$message({
            message: this.$t('api.orders.review.delSuccess'),
            type: 'success',
            duration: 2000
          })
          this.reviews.splice(0, 1)
        }).catch(err => {
          console.log(err)
        })
      })
    },
    initForm () {
      this.tags = this.reviewTags.map(t => ({ 'id': t.tag_id, 'name': t.tag_name }))
      this.tagOpt = objsToOpts(this.tags)
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>
